import { Form, DatePicker } from 'antd';
import { isWeekend } from '@/utils';
import dayjs from 'dayjs';
import classes from './index.module.css';
import ContentPanel from './ContentPanel';
import Buttons from './Buttons';
import { DESC, TITLE } from './const';
import './index.css';

export default function RALiveDate() {
  // const form = Form.useFormInstance();

  const disabledDate = (current) => isWeekend(current) || current < dayjs().endOf('day');

  return (
    <ContentPanel title={TITLE.third} desc={DESC.third} step={3}>
      <div className={classes.live_date}>
        <Form.Item label="Date" name="date" style={{ width: 500, fontSize: 16 }} className="date">
          <DatePicker
            className={classes.datePicker}
            format="MMM DD, YYYY"
            disabledDate={disabledDate}
          />
        </Form.Item>
        <span className={classes.date_tip}>ET</span>
      </div>

      <Form.Item
        shouldUpdate
      >
        {({ getFieldValue }) => (
          <Buttons
            backUrl="../widget-status"
            nextUrl="../review"
            isDisabled={!getFieldValue('date')}
          />
        )}

      </Form.Item>
    </ContentPanel>
  );
}
